var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9065 9.51585L24.125 15.7405V10.9395C24.125 9.60951 22.6533 8.80211 21.5315 9.51585L11.75 15.7405V1.9375C11.75 1.00551 10.9945 0.25 10.0625 0.25H2.1875C1.25551 0.25 0.5 1.00551 0.5 1.9375V30.0625C0.5 30.9945 1.25551 31.75 2.1875 31.75H34.8125C35.7445 31.75 36.5 30.9945 36.5 30.0625V10.9395C36.5 9.60944 35.0283 8.80211 33.9065 9.51585Z",
    fill: "#14D656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).a3edbef605c7407c834384d65854cc4c.svg";
export { ForwardRef as ReactComponent };